import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { selector } from 'recoil';
import { opcInfoAtom } from '../atoms/opcInfoAtom';
import { type CoverableInfoDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/opc';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { isLoggedOnSelector } from './isLoggedOnSelector';

export const getCoverableInfoSelector = selector<CoverableInfoDTO>({
    key: 'getCoverableInfoSelector',
    get: async ({ get }) => {
        const { productName, coverableId, isFromDAFlow } = get(opcInfoAtom);
        const { jobNumber, sessionId } = get(jobInfoAtom);
        const isLoggedOn = get(isLoggedOnSelector);

        return await OnlineSalesUnauthenticated.getCoverableInfoForOPC(
            jobNumber,
            sessionId,
            productName,
            coverableId,
            !!isFromDAFlow,
            !isLoggedOn
        );
    }
});
